function attachCustomFieldValidation(form) {
  const addToCartBtn = form.querySelector("button[name='add']");
  const customFields = form.querySelectorAll(".product-custom-fields input[required], .product-custom-fields textarea[required]");

  if (!addToCartBtn || !customFields.length) return;

  // Unikamy duplikatów errorów
  let errorMessage = form.querySelector(".product-custom-fields .custom-error-message");
  if (!errorMessage) {
    errorMessage = document.createElement("div");
    errorMessage.className = "custom-error-message";
    errorMessage.style.color = "red";
    errorMessage.style.fontSize = "13px";
    errorMessage.style.marginTop = "5px";
    errorMessage.style.display = "none";
    errorMessage.textContent = "⚠️ Please fill out all required fields before adding to cart.";
    form.querySelector(".product-custom-fields")?.appendChild(errorMessage);
  }

  addToCartBtn.addEventListener("click", function (e) {
    let valid = true;
    customFields.forEach(field => {
      if (field.value.trim() === "") {
        valid = false;
      }
    });

    if (!valid) {
      e.preventDefault();
      e.stopPropagation();
      errorMessage.style.display = "block";
      addToCartBtn.disabled = true;
      setTimeout(() => (addToCartBtn.disabled = false), 1000);
    } else {
      errorMessage.style.display = "none";
      setTimeout(() => {
        customFields.forEach(field => {
          if (field.tagName !== "SELECT") {
            field.value = "";
          }
        });
      }, 1200);
    }
  });
}

// Initial binding
function initCustomValidation() {
  const allForms = document.querySelectorAll("form[data-type='add-to-cart-form'], form[data-sticky-form]");
  allForms.forEach(form => attachCustomFieldValidation(form));
}

// Run on DOM ready
document.addEventListener("DOMContentLoaded", initCustomValidation);

// In case content is loaded dynamically (e.g., via AJAX or Turbo)
document.addEventListener("shopify:section:load", initCustomValidation);

